exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".terms-of-service-page{padding:200px;margin:0 auto;font-size:25px;display:flex;justify-content:center;align-items:center}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/guest/termsOfService/styles.less
 ** module id = 599
 ** module chunks = 0
 **/